import Swal from "sweetalert2";
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

const addEmployee = async (idUser, formData) => {
  return await api.post(
    UtilsUrl.rhURL() + `/employees/add_employee/${idUser}`,
    formData
  );
};
const checkemail = (email, idUser) => {
  return api.get(
    UtilsUrl.rhURL() + "/employees/checkemail/" + email + "/" + idUser
  );
};
const checkcin = (cin, idUser) => {
  return api.get(UtilsUrl.rhURL() + `/employees/checkcin/${cin}/${idUser}`);
};
const checkphone = (phone, idUser) => {
  return api.get(UtilsUrl.rhURL() + `/employees/checkphone/${phone}/${idUser}`);
};
const checknumcnss = (numcin, idUser) => {
  return api.get(
    UtilsUrl.rhURL() + `/employees/checknumcnss/${numcin}/${idUser}`
  );
};
const getEmployees = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/employees/" + idUser);
};
const updateEmployee = (iduser, employee) => {
  return api.put(
    UtilsUrl.rhURL() + `/employees/updateEmployee/` + iduser,
    employee
  );
};
const deleteEmployee = async (employeeID, setEmployees) => {
  try {
    const result = await Swal.fire({
      title: "Es-tu sûr?",
      text: "Vous ne pourrez pas annuler cette action !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      await api.put(
        UtilsUrl.rhURL() + `/employees/archive_employee/${employeeID}`,
        { isDeleted: true }
      );
      Swal.fire("Supprimé!", "L'employé est supprimé", "success");
      setEmployees((prevState) =>
        prevState.filter((employee) => employee.id !== employeeID)
      );
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Annulé", "l'emplyé n'est pas supprimé", "error");
    }
    // if (result.isConfirmed) {
    //     await api.put(UtilsUrl.rhURL() + `employees/archive_employee/${employeeID}`, { isDeleted: true });

    //     Swal.fire('Supprimé !', 'Employee supprimé avec succès.', 'success');

    //     setEmployees((prevState) => prevState.filter((employee) => employee.id !== employeeID));
    // } else if (result.dismiss === Swal.DismissReason.cancel) {
    //     Swal.fire('Cancelled', 'Your file is safe :)', 'error');
    // }
  } catch (error) {
    console.error(error);
  }
};
const checknumCnssExist = async (numcin, idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + `/employees/checknumcnss/${numcin}/${idUser}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const getEmployeeDetails = (idUser) => {
  return api.get(UtilsUrl.rhURL() + `/employees/employee/${idUser}`);
};
const updateEmployeePrime = async (idUser, userPrimeModel) => {
  const response = await api.put(
    UtilsUrl.rhURL() + `/primes/UpdateUserPrime/${idUser}`,
    userPrimeModel
  );
  return response.data;
};
const updateFamilySituation = async (idUser, employeeDetail) => {
  const response = await api.put(
    UtilsUrl.rhURL() + `/employees/updateFamilySituation/${idUser}`,
    employeeDetail
  );
  return response.data;
};

const getHistoriqueFicheDePaie = async (idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + `/ficheDePaie/historique_fiche_de_paie/` + idUser
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export {
  addEmployee,
  checkemail,
  checkcin,
  getEmployees,
  updateEmployee,
  deleteEmployee,
  checkphone,
  checknumcnss,
  checknumCnssExist,
  updateEmployeePrime,
  updateFamilySituation,
  getEmployeeDetails,
  getHistoriqueFicheDePaie,
};
